import { reactive } from 'vue';

export interface IRequestState {
  state: Record<string, RequestStateObj>;
  is: (requestKey: string) => RequestStateObj;
  setError: (requestKey: string, error: string) => void;
  setSending: (requestKey: string, abortController: AbortController) => void;
  setCompleted: (requestKey: string) => void;
  flushState: (requestKey: string) => void;
  abortRequest: (requestKey: string, reason?: string) => void;
}

type RequestStateObj = { sending: boolean, hasError: boolean, error: string | null, abortController?: AbortController }

const requestState = reactive<IRequestState>({
  state: {},
  is(requestKey) {
    return this.state[requestKey] || { sending: false, hasError: false, error: null };
  },

  setError(requestKey, error) {
    this.state[requestKey] = {
      sending: false,
      hasError: true,
      error,
    };
  },

  setSending(requestKey, abortController) {
    this.state[requestKey] = {
      sending: true,
      hasError: false,
      error: null,
      abortController,
    };
  },

  setCompleted(requestKey) {
    this.state[requestKey] = { sending: false, hasError: false, error: null };
  },

  flushState(requestKey) {
    delete this.state[requestKey];
  },

  abortRequest(requestKey, reason) {
    const request = this.is(requestKey);

    if (request.sending) return request.abortController?.abort(reason);
  },
});

export default requestState;